import React, { Component } from 'react';
import * as FontAwesome from 'react-icons/lib/fa';

export default class SubHeader extends Component {
  render() {
    return (
      <div className="pm-page-header pm-page-header--in-card">
        <div className="pm-page-header__title-block">
          <h1 className="pm-page-title">Frequency Master</h1>
          <p className="pm-page-subtitle">Manage occurrence frequencies and their scheduling types.</p>
        </div>
        <div className="pm-page-header__actions">
          <button className="pm-add-btn" onClick={this.props.toggle}>
            <FontAwesome.FaPlusCircle className="pm-add-btn__icon" />
            Add New Frequency
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/Accurence/accurence_subheader.js